import { TaskGateway } from './task-gateway.interface';

export const initTaskAPI = (apiSlice: any, gateway: TaskGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Task'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getAllTasksByUser: builder.query({
          query: gateway.getAllTasksByUser,
          providesTags: ['Task'],
        }),
        getTasksTypesByUser: builder.query({
          query: gateway.getTasksTypesByUser,
          providesTags: ['Task'],
        }),
        getTaskType: builder.query({
          query: gateway.getTaskType,
          providesTags: ['TaskType'],
        }),
        getTaskByProject: builder.query({
          query: gateway.getTaskByProject,
          providesTags: ['Task'],
        }),
        validateTask: builder.mutation({
          query: gateway.validateTask,
          invalidatesTags: ['Task', 'Project'],
        }),
        postTask: builder.mutation({
          query: gateway.postTask,
          invalidatesTags: ['Task'],
        }),
        patchTask: builder.mutation({
          query: gateway.patchTask,
          invalidatesTags: ['Task'],
        }),
        patchWelcomeCall: builder.mutation({
          query: gateway.patchWelcomeCall,
          invalidatesTags: ['Task'],
        }),
        noShowWelcomeCallEx: builder.mutation({
          query: gateway.noShowWelcomeCallEx,
          invalidatesTags: ['Task'],
        }),
        noShowWelcomeCall: builder.mutation({
          query: gateway.noShowWelcomeCall,
          invalidatesTags: ['Task'],
        }),
        patchTaskPieceComplementaire: builder.mutation({
          query: gateway.patchTaskPieceComplementaire,
          invalidatesTags: ['Task'],
        }),
        deleteTask: builder.mutation({
          query: gateway.deleteTask,
          invalidatesTags: ['Task'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface TaskSliceType {
  useGetAllTasksByUserQuery: Function;
  useLazyGetAllTasksByUserQuery: Function;
  useGetTasksTypesByUserQuery: Function;
  useGetTaskTypeQuery: Function;
  useGetTaskByProjectQuery: Function;
  useLazyGetTaskByProjectQuery: Function;
  useValidateTaskMutation: Function;
  usePostTaskMutation: Function;
  usePatchTaskMutation: Function;
  usePatchWelcomeCallMutation: Function;
  useNoShowWelcomeCallExMutation: Function;
  useNoShowWelcomeCallMutation: Function;
  usePatchTaskPieceComplementaireMutation: Function;
  useDeleteTaskMutation: Function;
}
